<template>
    <div>
        <div class="vx-row" v-if="this.travelOrders">
            <div class="vx-col w-full xl:w-1/6 lg:w-1/4 md:w-1/3">
                <vx-card :title="$t('Settings')" class="mb-3">
                    <p class="mt-6">{{$t("StartTime")}}</p>
                    <flat-pickr class="w-full" :config="configDateTimePicker" v-model="reportStartTime"></flat-pickr>
                    <p class="mt-6">{{$t("EndTime")}}</p>
                    <flat-pickr class="w-full" :config="configDateTimePicker" v-model="reportEndTime"></flat-pickr>
                    <vs-button class="mt-6" color="success" icon-pack="feather" icon="icon-edit" type="border" @click="updateTravelOrders">{{$t("Reload")}}</vs-button>
                </vx-card>
            </div>

            <div class="vx-col w-full xl:w-5/6">
                <vx-card :title="$t('TravelOrders')">

                    <div class="flex flex-wrap justify-between items-center">

                        <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">

                            <vs-dropdown vs-trigger-click class="cursor-pointer">
                                <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                                    <span class="mr-2">{{ currentPage * paginationPageSize - (paginationPageSize - 1) }} - {{ travelOrders.length - currentPage * paginationPageSize > 0 ? currentPage * paginationPageSize : travelOrders.length }} of {{ travelOrders.length }}</span>
                                    <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                                </div>

                                <vs-dropdown-menu>

                                    <vs-dropdown-item @click="gridApi.paginationSetPageSize(20)">
                                        <span>20</span>
                                    </vs-dropdown-item>
                                    <vs-dropdown-item @click="gridApi.paginationSetPageSize(50)">
                                        <span>50</span>
                                    </vs-dropdown-item>
                                    <vs-dropdown-item @click="gridApi.paginationSetPageSize(100)">
                                        <span>100</span>
                                    </vs-dropdown-item>
                                    <vs-dropdown-item @click="gridApi.paginationSetPageSize(150)">
                                        <span>150</span>
                                    </vs-dropdown-item>
                                </vs-dropdown-menu>
                            </vs-dropdown>
                        </div>


                        <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
                        <div class="flex flex-wrap items-center justify-between ag-grid-table-actions-right">
                            <vs-input class="mb-4 md:mb-0 mr-4" v-model="searchQuery" @input="updateSearchQuery" placeholder="Search..." />
                            <vs-button class="mb-4 md:mb-0" @click="generatePrintout">Generate PDF</vs-button>
                            <vs-button class="ml-3" type="border" color="success" @click="resizeColumns" icon-pack="feather" icon="icon-maximize-2"></vs-button>
                        </div>
                    </div>

                    <ag-grid-vue
                            ref="agGridTable"
                            :gridOptions="gridOptions"
                            class="ag-theme-material w-100 my-4 ag-grid-table"
                            :columnDefs="columnDefs"
                            :defaultColDef="defaultColDef"
                            :rowData="travelOrders"
                            :groupSelectsFiltered="true"
                            rowSelection="multiple"
                            colResizeDefault="shift"
                            domLayout="autoHeight"
                            :animateRows="true"
                            :floatingFilter="true"
                            :pagination="true"
                            :paginationPageSize="paginationPageSize"
                            :suppressPaginationPanel="true">
                    </ag-grid-vue>
                    <vs-pagination
                            :total="totalPages"
                            :max="maxPageNumbers"
                            v-model="currentPage" />

                </vx-card>
            </div>
        </div>
        <div class="vx-row" v-if="this.travelOrders">
        </div>
    </div>
</template>
<script>

    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';
    import { AgGridVue } from "ag-grid-vue"
    import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'

    export default {
        components: {
            flatPickr,
            AgGridVue,
        },
        data() {
            return {

                travelOrders: [],

                reportStartTime: null,
                reportEndTime: null,

                configDateTimePicker: {
                    enableTime: false,
                    dateFormat: 'd-m-Y',
                    locale: {
                        firstDayOfWeek: 1
                    }
                },

                searchQuery: '',
                gridOptions: {
                    suppressRowClickSelection: true,
                    onCellClicked: (e) => {
                        this.selectedTaskId = e.data.id;
                        this.$router.push({ name: 'travelOrder', params: { id: "" + this.selectedTaskId } })
                    },
                    onRowDataChanged: () => {
                        this.$nextTick(() => {
                            this.gridColumnApi.autoSizeColumns([ 'travel_order_id_string', 'day', 'vehicle', 'registration', 'driver']);
                            if(this.columnsWidth < this.tableWidth){
                                this.gridApi.sizeColumnsToFit()
                            }
                        });
                    }
                },
                maxPageNumbers: 7,
                gridApi: null,
                gridColumnApi: null,
                defaultColDef: {
                    sortable: true,
                    editable: false,
                    resizable: true,
                    suppressMenu: true,
                },
                columnDefs: [
                    {
                        headerName: "ID",
                        headerCheckboxSelection: true,
                        headerCheckboxSelectionFilteredOnly: true,
                        checkboxSelection: true,
                        field: 'travel_order_id_string',
                        filter: true,
                        width: 80
                    },
                    {
                        headerName: this.$t("Day"),
                        field: 'day',
                        filter: true,
                    },
                    {
                        headerName: this.$t("Vehicle"),
                        field: 'vehicle',
                        filter: true,
                    },
                    {
                        headerName: this.$t("Registration"),
                        field: 'registration',
                        filter: true,
                    },
                    {
                        headerName: this.$t("Driver"),
                        field: 'driver',
                        filter: true,
                    },
                ],
            }
        },
        methods: {
            resizeColumns(){
                this.gridColumnApi.autoSizeColumns([ 'travel_order_id_string', 'day', 'vehicle', 'registration', 'driver']);
                if(this.columnsWidth < this.tableWidth){
                    this.gridApi.sizeColumnsToFit()
                }
            },
            updateSearchQuery(val) {
                this.gridApi.setQuickFilter(val)
            },
            updateTravelOrders() {
                const thisIns = this;
                this.$http.post('/api/v1/travel_order/list', {
                    start_time: thisIns.moment(thisIns.reportStartTime, "DD-MM-YYYY").format(),
                    end_time: thisIns.moment(thisIns.reportEndTime, "DD-MM-YYYY").add(1, 'd').subtract(1, 'ms').format(),
                }).then(function (response) {
                    thisIns.travelOrders = response.data;
                }).catch(function (error) {
                    thisIns.$vs.notify({
                        title:'Error',
                        text: error,
                        color:'danger',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });
            },
            generatePrintout() {

                let list = [];
                const selectedRows = this.gridApi.getSelectedRows();

                if(selectedRows.length === 0) {
                    this.$vs.notify({
                        title:'Warning',
                        text: "No data selected!",
                        position:'top-right',
                        color:'warning',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'});
                    return
                }

                for(let x = 0; x < selectedRows.length; x++) {

                    list.push(selectedRows[x].id);

                }

                const thisIns = this;
                this.$http.post('/api/v1/travel_order/list/generate', JSON.stringify(list)).then(function (response) {
                    thisIns.$vs.notify({
                        title:'Success',
                        text: "Created",
                        color:'success',
                        position:'top-right',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'});

                    thisIns.$vs.loading.close("#previewButton > .con-vs-loading");
                    if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
                        || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))) {
                        window.location.href = "/pdf/travel_order_combined/" + response.data;
                    }else{
                        window.open("/pdf/travel_order_combined/" + response.data, "_blank");
                    }
                }).catch(function (error) {
                    thisIns.$vs.notify({
                        title:'Error',
                        text: error.response.data,
                        color:'danger',
                        position:'top-right',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });
            }
        },
        computed: {
            columnsWidth() {
                let total = 0;
                let state = this.gridColumnApi.getColumnState();
                for(let x = 0; x < state.length; x++){
                    total += state[x].width
                }
                return total;
            },
            tableWidth() {
                return this.gridApi.gridPanel.eBodyViewport.clientWidth;
            },
            paginationPageSize() {
                if(this.gridApi) return this.gridApi.paginationGetPageSize()
                else return 50
            },
            totalPages() {
                if(this.gridApi) return this.gridApi.paginationGetTotalPages()
                else return 0
            },
            currentPage: {
                get() {
                    if(this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1
                    else return 1
                },
                set(val) {
                    this.gridApi.paginationGoToPage(val - 1)
                }
            }
        },
        created() {
            this.reportEndTime = new Date();
            this.reportStartTime = new Date(this.reportEndTime.getFullYear(), this.reportEndTime.getMonth(), 1);
            this.updateTravelOrders();
        },
        mounted() {
            this.gridApi = this.gridOptions.api;
            this.gridColumnApi = this.gridOptions.columnApi;
        },
    }
</script>
